{
	"closePosition": {
		"title": "Close Position",
		"positionSize": "Position size",
		"ticker": "Ticker",
		"price": "Price",
		"profitabilityInDollar": "Profitability in $",
		"totalPcs": "Total, pcs",
		"position": "Position",
		"averagePrice": "Average Price",
		"profitabilityInPercent": "Profitability in %",
		"availablePcs": "Available, pcs",
		"orderType": "Order Type",
		"orderDuration": "Order Duration",
		"cancelOpenedOrders": "Cancel Opened Orders",
		"cancel": "Cancel",
		"qty": "Pcs.",
		"qtySlider": "{{qty}} pcs.",
		"confirmButton": "Close position"
	}
}
